module.exports = __webpack_public_path__ + "static/media/34DSS10.942d1e14.jpg";